import { motion } from "framer-motion";

function Industries() {
  const industriesList = [
    "Financial Services", "Healthcare", "B2B E-commerce", 
    "Education", "Manufacturing", "Public Sector"
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemAnim = {
    hidden: { opacity: 0, x: -20 },
    show: { opacity: 1, x: 0, transition: { duration: 0.4 } }
  };

  return (
    <section className="industries" id="portfolio">
      <motion.div 
        className="section-header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <span className="section-tag">Sectors</span>
        <h2 className="section-title">Industries We Serve</h2>
      </motion.div>

      <motion.div 
        className="industry-grid"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
      >
        {industriesList.map((industry, index) => (
          <motion.div className="industry-card" key={index} variants={itemAnim}>
            <h3>{industry}</h3>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}

export default Industries;